import { cn } from '@/lib/utils';

interface PithLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

/**
 * Pith wordmark - Libre Baskerville Bold
 */
export function PithLogo({ size = 'md', className }: PithLogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl',
    xl: 'text-5xl',
  };

  return (
    <span className={cn('font-serif font-bold tracking-tight', sizeClasses[size], className)}>
      Pith
    </span>
  );
}
